module.exports = __webpack_public_path__ + "img/grapes.f578f326.jpg";